import styled from 'styled-components';

export const InfoPMT = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;

  @media screen and (max-width: 991px) {
    justify-content: flex-start;
  }
`;

export const InfoPMTMessage = styled.span`
  display: flex;
  justify-content: space-between;
  width: 32.75%;
  margin-top: -16px;
  font-size: 12px;
  gap: 4px;
  text-align: justify;

  @media screen and (max-width: 991px) {
    width: 49%;
  }

  @media screen and (max-width: 768px) {
    width: 98%;
  }
`;
